module.exports = __webpack_public_path__ + "static/img/produtos_g.6f87c32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/limao/produtos_g.png
// module id = G/ZB
// module chunks = 0